var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 9.33219V7.33219H10.4998V5.99886H12.4998V3.99886H13.8332V5.99886H15.8332V7.33219H13.8332V9.33219H12.4998ZM6.49984 7.99886C5.7665 7.99886 5.13873 7.73775 4.6165 7.21553C4.09428 6.69331 3.83317 6.06553 3.83317 5.33219C3.83317 4.59886 4.09428 3.97108 4.6165 3.44886C5.13873 2.92664 5.7665 2.66553 6.49984 2.66553C7.23317 2.66553 7.86095 2.92664 8.38317 3.44886C8.90539 3.97108 9.1665 4.59886 9.1665 5.33219C9.1665 6.06553 8.90539 6.69331 8.38317 7.21553C7.86095 7.73775 7.23317 7.99886 6.49984 7.99886ZM1.1665 13.3322V11.4655C1.1665 11.0877 1.26373 10.7405 1.45817 10.4239C1.65262 10.1072 1.91095 9.86553 2.23317 9.69886C2.92206 9.35442 3.62206 9.09608 4.33317 8.92386C5.04428 8.75164 5.7665 8.66553 6.49984 8.66553C7.23317 8.66553 7.95539 8.75164 8.6665 8.92386C9.37762 9.09608 10.0776 9.35442 10.7665 9.69886C11.0887 9.86553 11.3471 10.1072 11.5415 10.4239C11.7359 10.7405 11.8332 11.0877 11.8332 11.4655V13.3322H1.1665Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.db49adab7a2c51e06c72a7302fb176bb.svg";
export { ForwardRef as ReactComponent };